import countries from '@/datasources/countries'
import { mapEntries } from '@/utils/maps'

/**
 * Countries Map mixin
 * @mixin
 */
export default {
	computed: {
		// @todo - Mixin?
		countriesMap() {
			return mapEntries(countries, { key: 'code' })
		},
	},

	methods: {
		getCountry(code) {
			const country = this.countriesMap[code]
			return country ? country.name : 'UNDEFINED'
		},
	},
}
